var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Input, SearchIcon, styled } from '@auth0/quantum-product';
import * as React from 'react';
import performSearchAction from '../../action/performSearch';
import { useFluxible } from '../hooks/useFluxible';
import { ContentContainer } from '../layouts';
var SearchInput = styled(Input)(function (_a) {
    var _b;
    var theme = _a.theme, placement = _a.placement;
    if (placement === 'homepage') {
        return {
            height: theme.spacing(8),
            borderRadius: theme.spacing(3),
            fontSize: theme.typography.body1.fontSize,
            paddingLeft: theme.spacing(3),
        };
    }
    if (placement === 'header') {
        return _b = {
                width: 260
            },
            _b[theme.breakpoints.down('md')] = {
                display: 'none',
            },
            _b[theme.breakpoints.down(theme.layout.sidebarWidth + theme.layout.articleContentWidth + theme.spacingPX(5))] = {
                width: 172,
            },
            _b;
    }
    return {};
});
var SearchWrapper = styled(ContentContainer)(function (_a) {
    var _b;
    var theme = _a.theme, placement = _a.placement;
    if (placement === 'header' || placement === 'drawer') {
        return _b = {
                width: 'auto',
                maxWidth: 'auto',
                margin: 0
            },
            _b[theme.breakpoints.down(theme.layout.tabletBreakpoint)] = {
                margin: 0,
            },
            _b;
    }
    return {};
});
export var SearchBox = function (_a) {
    var _b = _a.placeholder, placeholder = _b === void 0 ? 'Search the docs' : _b, _c = _a.text, text = _c === void 0 ? '' : _c, _d = _a.placement, placement = _d === void 0 ? 'header' : _d, onChange = _a.onChange;
    var inputElRef = React.useRef(null);
    var _e = __read(React.useState(text), 2), textState = _e[0], setTextState = _e[1];
    var _f = __read(React.useState(false), 2), focused = _f[0], setFocused = _f[1];
    var executeAction = useFluxible().executeAction;
    React.useEffect(function () {
        setTextState(text);
    }, [text]);
    React.useEffect(function () {
        if (focused && inputElRef.current) {
            inputElRef.current.select();
        }
    }, [focused]);
    var handleSubmit = function (evt) {
        evt.preventDefault();
        if (inputElRef.current) {
            inputElRef.current.blur();
        }
        executeAction(performSearchAction, { query: textState });
        if (onChange) {
            onChange(textState);
        }
    };
    return (React.createElement("form", { id: "search", role: "search", autoComplete: "off", onSubmit: handleSubmit },
        React.createElement(SearchWrapper, { placement: placement },
            React.createElement(SearchInput, { startAdornment: React.createElement(SearchIcon, { size: 18, style: { marginRight: 12 }, onClick: function () { return setFocused(true); } }), id: "search-input", size: placement === 'header' ? 'small' : 'medium', placement: placement, inputRef: inputElRef, type: "text", placeholder: placeholder, value: textState, onChange: function (evt) { return setTextState(evt.target.value); }, onFocus: function () { return setFocused(true); }, onBlur: function () { return setFocused(false); } }))));
};
